export default "__VITE_ASSET__Dby6bq1y__"